<template>
  <OffersCarouselShimmer v-if="isLoading" />
  <section v-else class="w-full">
    <div class="space-y-4">
      <CarouselCard
        v-for="(offer, idx) in offers"
        :key="offer.id"
        :offer="offer"
        :offer-idx="idx"
        :has-same-destination-city="hasSameDestinationCity"
        :source="`${source}.${idx}`"
        :cashback-click-source="cashbackClickSource"
        @click="handleCardClick(idx)"
        @onCashbackClick="emit('onCashbackClick')"
      />
    </div>
  </section>
</template>

<script setup lang="ts">
  import type { specialOffers } from 'shared';
  import { useRouter } from 'vue-router';

  import {
    buildSearchQuery,
    saveCitiesFromOffer,
  } from '@/features/offers/model';

  import type { hotOffersTypes } from '@/entities/hot-offers';

  import type { analyticsEventsLib } from '@/shared/lib';

  import OffersCarouselShimmer from './OffersCarouselShimmer.vue';
  import CarouselCard from './CarouselCard.vue';

  const props = defineProps<{
    isLoading: boolean;
    offers: hotOffersTypes.MappedHotOffer[];
    currentSpecialOffer?: specialOffers.Special;
    hasSameDestinationCity?: boolean;
    source?: string;
    cashbackClickSource: analyticsEventsLib.config.SearchResultCardCashbackPriceClickSource;
  }>();

  const emit = defineEmits<{
    onCashbackClick: [];
  }>();

  const router = useRouter();

  const handleCardClick = (offerIdx: number) => {
    const offer = props.offers[offerIdx];
    const { query: hashCode, source } = buildSearchQuery(
      offer,
      props.currentSpecialOffer,
    );
    saveCitiesFromOffer(offer);
    router.push({
      name: 'OffersResults',
      params: {
        hashCode,
        source,
      },
    });
  };
</script>
